<div class="gears">
    <svg id="logo" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 261 30" style="enable-background:new 0 0 261 30;" xml:space="preserve">
<style type="text/css">
 .st0{fill:#FFFFFF;}
</style>
<g>
 <path  d="M84,11.3h5.79v1.42h-4.01v1.59h3.46v1.37h-3.46v1.59h4.01v1.41H84V11.3z" stroke="white" stroke-width="0.3" />
 <path d="M94.95,11.3l0.01,2.99h3.42V11.3h1.77v7.39h-1.77v-2.98h-3.42v2.98h-1.77V11.3H94.95z" stroke="white" stroke-width="0.3"/>
 <path  d="M103.82,11.3h1.81l2.29,3.48l2.31-3.48h1.81v7.39h-1.77v-4.56l-2.34,3.59l-2.32-3.59v4.56h-1.77V11.3z" stroke="white" stroke-width="0.3"/>
 <path  d="M115.7,15.86V11.3h1.77v4.56c0,0.81,0.52,1.51,1.48,1.51c0.99,0,1.49-0.7,1.49-1.51l-0.01-4.56h1.77l0.01,4.56
     c0,1.92-1.51,2.95-3.25,2.95C117.21,18.81,115.7,17.79,115.7,15.86z" stroke="white" stroke-width="0.3"/>
 <path  d="M131.17,17.26v1.44h-5.33V11.3h1.77v5.96H131.17z" stroke="white" stroke-width="0.3"/>
 <path  d="M137.15,11.3h1.86l3.36,7.39h-1.86l-0.61-1.36h-3.63l-0.61,1.36h-1.87L137.15,11.3z M136.89,15.92h2.37
     l-1.18-2.6L136.89,15.92z" stroke="white" stroke-width="0.3"/>
 <path  d="M144.15,11.3h6.35v1.44h-2.29v5.96h-1.77v-5.96h-2.28V11.3z" stroke="white" stroke-width="0.3"/>
 <path  d="M155.42,18.7h-1.77V11.3h1.77V18.7z" stroke="white" stroke-width="0.3"/>
 <path  d="M162.78,11.19c2.27,0,3.99,1.68,3.98,3.79c-0.01,2.14-1.73,3.83-3.98,3.83c-2.26,0-3.98-1.72-3.98-3.83
     C158.79,12.84,160.53,11.19,162.78,11.19z M162.78,17.3c1.22,0,2.22-1.06,2.22-2.32c-0.01-1.27-0.99-2.27-2.22-2.27
     c-1.21,0-2.21,1-2.21,2.27C160.57,16.25,161.56,17.3,162.78,17.3z" stroke="white" stroke-width="0.3"/>
 <path  d="M171.88,11.3l3.35,4.61V11.3H177v7.39h-1.85l-3.32-4.59v4.59h-1.77V11.3H171.88z" stroke="white" stroke-width="0.3"/>
</g>
</svg>
</div>

<div class="loaderbguntouch"></div>